import { PageHero } from "@/components/PageHero";
import { siteConfig } from "@/data/siteConfig";
import { useSiteContent } from "@/context/ContentContext";

function LegalBody({ title, updated, blocks }) {
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <p className="text-xs font-semibold uppercase tracking-wider text-muted">Last updated: {updated}</p>
        <div className="mt-8 space-y-8">
          {blocks.map((b, i) => (
            <div key={i}>
              <h2 className="font-display uppercase text-2xl tracking-wide text-ink">{b.h}</h2>
              <p className="mt-3 text-[16px] leading-relaxed text-muted">{b.p}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Privacy() {
  const { contact } = useSiteContent();
  const blocks = [
    { h: "Overview", p: "This Privacy Policy explains how Ocean Exports handles information submitted through enquiry forms." },
    { h: "Information We Collect", p: "Details you provide via the Request a Quote form, such as name, company, contact details and part requirements." },
    { h: "How We Use Information", p: "To respond to enquiries and process parts quotations." },
    { h: "Contact", p: `For privacy questions, contact ${contact.email}.` },
  ];
  return (
    <>
      <PageHero kicker="Legal" title="Privacy Policy" />
      <LegalBody title="Privacy Policy" updated={siteConfig.legal.privacyUpdated} blocks={blocks} />
    </>
  );
}

export function Terms() {
  const { contact } = useSiteContent();
  const blocks = [
    { h: "Use of Website", p: "These terms govern use of the Ocean Exports website." },
    { h: "Enquiries & Quotations", p: "Quotations are provided based on enquiry details and do not constitute a binding offer unless confirmed." },
    { h: "Intellectual Property", p: "All site content is owned by or licensed to Ocean Exports." },
    { h: "Contact", p: `For questions about these terms, contact ${contact.email}.` },
  ];
  return (
    <>
      <PageHero kicker="Legal" title="Terms & Conditions" />
      <LegalBody title="Terms" updated={siteConfig.legal.termsUpdated} blocks={blocks} />
    </>
  );
}
